
      const columnCheck = {
  "deviceModel": "Модель",
  "deviceExtra": "Экстра",
  "devicePhoneNo": "Номер телефона",
  "IMSI": "IMSI",
  "ICCID": "ICCID",
  "manufacturer": "Производитель",
  "serialNumber": "Серийный номер",
  "softwareVersion": "Версия ПО",
  "productionDate": "Дата производства",
  "deviceOrg": "Орг.",
  "deviceStatus": "Статус",
  "deviceRemark": "Ремарка",
  "packageDate": "Дата упаковки",
  "operate": "Функционирование",
  "alarmType": "Тип тревоги",
  "alarmLevel": "Уровень тревоги",
  "name": "Название",
  "alarmTime": "Время тревоги",
  "group": "Группа",
  "alarmStatus": "Статус",
  "notice": "Заметка",
  "description": "Описание",
  "power": "Мощность",
  "lastOnlineTime": "Последнее время в режиме online",
  "joinGroupTime": "Время присоединения к группе",
  "absent": "Отсутствует",
  "segregationTime": "Время изоляции",
  姓名:'Имя',
  照片:'Фотографии',
  证件号码:'Номер документа',
  身份证号:'Номер удостоверения личности',
  住址:'Адрес',
  出生日期:'Дата рождения',
  电话:'Телефон',
  入矫时间:'Время поступления на коррекцию',
  矫正计划:'План коррекции',
  人员:'персонал'
}
      export default columnCheck
    